import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../hooks/use-services.hook";
import {FlightSearchStationSelectionPage} from "./flight-search-station-selection.page";
import {PlaneLandingFilledLineIcon} from "../../../assets/svg/plane-landing-filled-line.icon";

export const FlightSearchDestinationSelectionPage: React.FC = observer(() => {
    const services = useServices();
    const searchController = services.flightSearch.searchController;
    return (
        <FlightSearchStationSelectionPage titleText={services.language.translate('Going To')}
                                          plainIcon={<PlaneLandingFilledLineIcon size={1.6} />}
                                          stations={searchController.availableReturnStations}
                                          recentlySearchedStations={searchController.recentlySearchedDestinations}
                                          onStationSelected={async (station) => {
                                  searchController.departureDestination = station;
                                  await services.flightSearch.steps.nextStep();
                              }} />
    );
});
